<template>
  <div
    class="mx-1 outline-none cursor-pointer bg-gray-200 hover:bg-gray-300 text-gray-600 hover:text-gray-700 font-semibold relative block rounded-lg"
    style="-webkit-tap-highlight-color: transparent;"
    :class="{ ['active shadow-outline']: isActive }"
    tabindex="0"
    @focus="onFocus"
    @click="onClick"
    @keydown.left.down.prevent="
      componentType == 'input-number'
        ? update(localValue - 1)
        : update(!localValue)
    "
    @keydown.right.up.prevent="
      componentType == 'input-number'
        ? update(localValue + 1)
        : update(!localValue)
    "
  >
    <!-- remove mx-1 once header fixsed -->
    <div
      class="label pr-3 pl-5 sm:pr-5 sm:pl-7 py-2 w-full relative overflow-hidden rounded-lg
  flex flex-row justify-between align-middle"
      :class="{
        ['label fill text-gray-200']: wasBlurred && !isActive,
        ['noFill text-gray-800']: isActive,
        ['label noFill']: !wasBlurred && !isActive
      }"
    >
      <div
        @click.capture.stop="labelClick"
        class="py-3 flex flex-col text-left leading-none justify-center"
      >
        <div v-if="title" class="text-2xl sm:text-3xl">
          {{ title | capitalize }}
        </div>
        <div
          v-if="subtitle && subtitle.length > 0"
          class="font-extralight text-base sm:text-xl mt-2"
        >
          {{ subtitle }}
        </div>
      </div>

      <div class="flex items-center my-auto min-h-20">
        <component
          v-if="inputType"
          :is="componentType"
          :active="isActive"
          :value="localValue"
          ref="input"
          @update="update"
          :class="[
            componentType == 'input-number'
              ? 'text-4xl sm:text-5xl mr-2 sm:mr-0'
              : isActive
              ? 'text-2xl sm:text-3xl mr-2 sm:mr-0'
              : 'text-4xl sm:text-5xl'
          ]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputNumber from '@/components/InputNumber'
import InputBoolean from '@/components/InputBoolean'

export default {
  name: 'OrderItem',
  props: {
    index: {
      type: Number,
      required: true
    },
    activeItem: {
      type: Number,
      required: false,
      default: null
    },
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    subtitle: {
      type: String,
      required: false,
      default: null
    },
    value: {
      validator: prop => {
        return (
          typeof prop === 'number' || typeof prop === 'boolean' || prop === null
        )
      },
      required: false,
      default: null
    },
    inputType: {
      type: String,
      required: false,
      default: null
    },
    maxValue: {
      type: Number,
      required: false,
      default: 150
    },
    minValue: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      localValue: null,
      valueOnLastBlur: null,
      wasFocused: false,
      wasBlurred: false,
      secondClick: false
    }
  },
  components: {
    InputNumber,
    InputBoolean
  },
  computed: {
    isActive() {
      return this.activeItem === this.index
    },
    componentType() {
      switch (this.inputType) {
        case 'boolean':
        case 'booleanTrue':
          return 'input-boolean'
        case 'number':
        default:
          return 'input-number'
      }
    }
  },
  watch: {
    isActive(newValue) {
      this.wasFocused = true
      this.wasBlurred = !newValue
    },
    wasBlurred(newValue) {
      if (newValue) this.onBlur()
    },
    value(newValue) {
      if (newValue === null) {
        this.wasFocused = this.wasBlurred = false
        this.localValue = this.valueOnLastBlur = null
      }
      this.localValue = newValue
    }
  },
  mounted() {
    if (this.value !== null) this.wasBlurred = this.wasFocused = true
    this.localValue = this.valueOnLastBlur = this.value
    //this.putOrderItem()
  },
  methods: {
    labelClick() {
      //console.log('labelClick')
      if (this.isActive)
        if (!this.secondClick) this.secondClick = true
        else this.$emit('showProductCountingInfo', this.id)
      else this.onClick()
    },
    onFocus() {
      //console.log('onFocus')
      if (this.value === null) {
        this.localValue = this.inputType === 'number' ? 0 : false
        this.putOrderItem()
      }
      // else if (!this.wasFocused) {
      //   this.valueOnLastBlur = this.localValue
      // }
      this.$emit('clicked', this.index)
      // if (!this.secondClick) this.secondClick = true
    },
    onClick() {
      //console.log('onClick')
      if (this.value === null) {
        this.localValue = this.inputType === 'number' ? 0 : false
        this.putOrderItem()
      }

      // else if (!this.wasFocused) {
      //   this.valueOnLastBlur = this.localValue
      // }
      this.$emit('clicked', this.index)
    },
    onBlur() {
      // if the value changed since last save, update firestore
      if (this.valueOnLastBlur != this.localValue) {
        this.putOrderItem()
        // update saved value for next blur event
        // this.valueOnLastBlur = this.localValue
      }
      this.secondClick = false
    },
    update(value) {
      if (typeof value === 'number') {
        if (value > this.maxValue || value < this.minValue) {
          return
        }
      }
      this.localValue = value
    },
    putOrderItem() {
      this.$emit('putValue', {
        [this.id]: this.localValue
      })
      this.valueOnLastBlur = this.localValue
    }
  }
}
</script>

<style lang="scss" scoped>
.active {
  @apply bg-white;
}

.active:hover {
  @apply bg-white cursor-default;
}

.label {
  z-index: 2;
}

.label:before {
  @apply bg-gray-800 rounded-lg absolute opacity-0;
  width: 20px;
  height: 10px;
  content: '';
  left: 50%;
  top: 50%;

  will-change: transform;
  transform: translate(-50%, -50%) scale3d(1, 1, 1);
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1);
  z-index: -1;
}

.label:hover:before {
  @apply bg-gray-700;
}

.label.fill:before {
  @apply opacity-100;
  will-change: transform;
  transform: translate(-50%, -50%) scale3d(56, 56, 1);
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1);
  z-index: -1;
}
</style>
